export const AUTH = {
  registerUser: "common/register",
  loginUser: "common/login",
  changePassword: "common/changepassword",
  forgotPassword: "common/forgotpassword",
  logoutUser: "common/logout",
  updateProfile: "common/updateprofile",
};
